import { render, staticRenderFns } from "./QuickAddTaskModal.vue?vue&type=template&id=1aa5eb76&scoped=true&class=fill-height&"
import script from "./QuickAddTaskModal.vue?vue&type=script&lang=ts&"
export * from "./QuickAddTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./QuickAddTaskModal.vue?vue&type=style&index=0&id=1aa5eb76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa5eb76",
  null
  
)

export default component.exports